import React from "react";
import ChatBubble from "./ChatBubble";
import type { ChatMessage } from "../../store/@types/chat";

type ChatMessageListProps = {
  messages: ChatMessage[];
};

const ChatMessageList: React.FC<ChatMessageListProps> = ({ messages }) => {
  return (
    <div className="flex h-[423px] max-h-[423px] flex-none flex-col gap-3 overflow-y-auto px-5 py-5">
      {messages.map((message) => (
        <ChatBubble key={message.id} message={message} />
      ))}
    </div>
  );
};

export default ChatMessageList;
